import { Alert, Center, Loader, Table, Text } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { SendOut } from "../../services/sendOuts.service";
import { TissueCypherSendOutRow } from "./TissueCypherSendOutRow";

interface TissueCypherSendOutTableProps {
  sendOuts: SendOut[];
  isLoading: boolean;
  hasError: boolean;
  emptyMessage: string;
  onView: (sendOut: SendOut) => void;
  onShip: (sendOut: SendOut) => void;
}

export function TissueCypherSendOutTable({
  sendOuts,
  isLoading,
  hasError,
  emptyMessage,
  onView,
  onShip,
}: TissueCypherSendOutTableProps) {
  if (isLoading) {
    return (
      <Center p="xl">
        <Loader aria-label="Loading Tissue Cypher send-outs" />
      </Center>
    );
  }
  if (hasError) {
    return (
      <Alert
        icon={<IconAlertCircle size={16} />}
        color="red"
        variant="light"
        title="Send-outs unavailable"
      >
        Tissue Cypher send-outs could not be loaded. Refresh the queue to try
        again.
      </Alert>
    );
  }
  if (sendOuts.length === 0)
    return (
      <Text c="dimmed" ta="center" py="xl">
        {emptyMessage}
      </Text>
    );
  return (
    <Table.ScrollContainer minWidth={760}>
      <Table striped highlightOnHover>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Case #</Table.Th>
            <Table.Th>Destination</Table.Th>
            <Table.Th>Materials</Table.Th>
            <Table.Th>Status</Table.Th>
            <Table.Th>Created</Table.Th>
            <Table.Th>Actions</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {sendOuts.map((sendOut) => (
            <TissueCypherSendOutRow
              key={sendOut.id}
              sendOut={sendOut}
              onView={onView}
              onShip={onShip}
            />
          ))}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  );
}
